/**
 * Anti-Spoiler Sync — thin compatibility wrapper over the GlobalTvOffsetBus.
 *
 * Phase 0 unified the spoiler/manual/mic offsets into a single bus. This
 * hook is retained so legacy callers (SpoilerSyncSlider, etc.) keep
 * working without changes. New code should call `useGlobalTvOffset()`
 * from `@/lib/sync/globalTvOffsetBus` directly.
 */
import { useCallback } from "react";
import {
  useGlobalTvOffset,
  setGlobalOffset,
} from "@/lib/sync/globalTvOffsetBus";

export { useDelayedSignal } from "@/lib/sync/globalTvOffsetBus";

export function useSpoilerOffset() {
  const { offsetSec } = useGlobalTvOffset();
  // Spoiler slider historically exposed 0..60; clamp to non-negative on read.
  const positive = Math.max(0, Math.round(offsetSec));
  const setOffset = useCallback((sec: number) => {
    setGlobalOffset(Math.max(0, Math.round(sec)), "spoiler");
  }, []);
  return { offsetSec: positive, setOffset };
}